export default "__VITE_ASSET__ht_I9NAi__"